import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RepairStatusComponent } from '@routes/dialogs/repair-status/repair-status.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

interface Event {
  type: string;
  payload?: any;
}

type EventCallback = (payload: any) => void;

@Injectable({
  providedIn: 'root'
})
export class EventService {

  closeTab$ = new Subject<any>();
  changeTab$ = new Subject<any>();
  selectTickets$ = new Subject<any>();
  bsModalRef: BsModalRef;
  private handler = new Subject<Event>();

  constructor(private modalService: BsModalService) {
  }

  /**
   * Broadcast the event
   * @param type type of event
   * @param payload payload
   */
  broadcast(type: string, payload = {}) {
    this.handler.next({ type, payload });
  }

  /**
   * Subscribe to event
   * @param type type of event
   * @param callback call back function
   */
  subscribe(type: string, callback: EventCallback): Subscription {
    return this.handler.pipe(
      filter(event => event.type === type)).pipe(
      map(event => event.payload))
      .subscribe(callback);
  }

  statusClick($event, processType, detailType, status) {
    console.log('$event = ', $event, 'processType =', processType, ', detailType = ', detailType, ', status = ', status);
    const getTitle = (processType, detailType) => {
      if(processType === 'ZR01') {
        return 'Request Status';
      } else {
        if(detailType === 'DET001') {
          return 'Repair Status';
        } else {
          return 'Exchange Status';
        }
      }
    };
    $event.stopPropagation();
    $event.preventDefault();
    const initialState = {
      title: getTitle(processType, detailType),
      status,
      processType,
      detailType,
    };
    this.bsModalRef = this.modalService.show(RepairStatusComponent, {
      class: 'modal-lg',
      initialState,
    });
  }
}
